<template>
  <div>
    <px-view-header title="Agrupar solicitações"
                    title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>
    <div>
      <px-requisicao-geracao-table/>
    </div>
  </div>
</template>

<script>
import RequisicaoGeracaoTable from '@/modules/requisicao/geracao/RequisicaoGeracaoTable.vue';

export default {
  data() {
    return {
      breadcrumbs: [
        { text: 'Gestão de compras' },
        {
          text: 'Solicitações',
          to: '/requisicoes',
        },
        { text: 'Agrupar solicitações' },
      ],
    };
  },
  methods: {
    onClickBack() {
      this.$router.push({ name: 'main.requisicoes' });
    },
  },
  components: {
    pxRequisicaoGeracaoTable: RequisicaoGeracaoTable,
  },
};
</script>
